import styled from 'styled-components';
import Switch from 'react-switch';
import { TTicketData } from '@/components/ticketingNew/pages/Order';
import { useRecoilValue, translationDataState, tourConfigsState } from '../../../store';
import { capitalize } from '@/utils/string';

const TicketItemMainWrap = styled.div<{ rtl?: boolean }>`
  &.bl-ticket-item {
    height: 141px;
    display: flex;
    margin-bottom: 11px;

    .bl-ticket-desc {
      width: 108px;
      min-width: 108px;
      background: #ffffff;
      border-radius: 0 12px 12px 0;
      margin-right: 3px;
      filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.14));
      text-align: center;
      position: relative;
      ${({ rtl }) =>
        `${rtl ? 'margin-left: 3px; margin-right: 0; border-radius: 12px 0 0 12px;' : ''}`};

      .bl-ticket-number-text {
        margin-top: 17px;
        font-weight: 500;
        font-size: 14px;
        line-height: 21px;
      }

      .bl-ticket-number {
        font-weight: 400;
        font-size: 60px;
        line-height: 90px;
      }

      .bl-ticket-triangle {
        width: 0;
        height: 0;
        border-bottom: 29px solid #ea475c;
        border-right: 49px solid transparent;
        position: absolute;
        bottom: 0;
        ${({ rtl }) => `${rtl ? 'transform: scale(-1, 1); right: -1px;' : ''}`};
      }
    }

    .bl-ticket-data {
      padding-top: 29px;
      padding-left: 20px;
      padding-right: 54px;
      width: 100%;
      background: #ffffff;
      border-radius: 12px 0 0 12px;
      filter: drop-shadow(0px 2px 6px rgba(0, 0, 0, 0.14));
      ${({ rtl }) => `${rtl ? 'border-radius: 0 12px 12px 0; padding: 29px 20px 0 54px;' : ''}`};

      label {
        display: flex;
        font-weight: 400;
        font-size: 15px;
        line-height: 22px;
        margin-bottom: 19px;
        justify-content: space-between;

        span {
          ${({ rtl }) => `${rtl ? 'right:12px;left:initial!important;' : ''}`};
        }

        .bl-text-input {
          height: 23px;
          width: 251px;
          border: 1px solid #c4c4c4;
          box-sizing: border-box;
          border-radius: 4px;

          &:active,
          &:focus {
            outline-color: #c4c4c4;
          }
        }
      }

      .bl-field-2 {
        label {
          margin-bottom: 15px;
        }
      }

      .bl-field-3 {
        label {
          font-weight: 400;
          font-size: 12px;
          line-height: 20px;
          justify-content: space-between;
          width: 117px;
          float: right;
        }

        .bl-field-close {
          float: left;
          display: flex;
          align-items: baseline;
          cursor: pointer;
          color: #ea475c;
          //line-height: 13px;
          font-weight: 400;
          font-size: 12px;
          line-height: 15px;

          .bl-close-circle {
            width: 13px;
            height: 13px;
            display: flex;
            align-items: center;
            justify-content: center;
            background-color: #ea475c;
            margin: 6px;
            color: white;
            border-radius: 50%;

            i {
              font-weight: normal;
              font-size: 10px;
            }
          }
        }
      }

      .bl-ticket-ending {
        position: absolute;
        height: 141px;
        right: 0;
        top: 0;
        ${({ rtl }) => `${rtl ? 'right: initial;left: -2px;transform: scale(-1,1);' : ''}`};

        .bl-ticket-end-rect {
          width: 18px;
          height: 21px;
          background: #e5e5e5;
          border-radius: 12px 0 0 12px;

          &.bl-rect-1 {
            margin-top: 20px;
          }

          &.bl-rect-2 {
            margin-top: 19px;
          }

          &.bl-rect-3 {
            margin-top: 19px;
          }
        }
      }

      @media screen and (max-width: 760px) {
        ${({ rtl }) =>
          `${rtl ? 'padding-left:20px!important;padding-right: 10px!important;' : ''}`};
      }
    }
  }
`;

const UserCard = (props: {
  ticket: TTicketData;
  ticketNum: number;
  setTicketData: (arg: { id: number; target: string; value: any }) => void;
  removeTicket: (id: number) => void;
}) => {
  const { ticket, ticketNum, setTicketData, removeTicket } = props;
  const {
    user = 'User',
    full_name = 'Full name',
    email = 'Email',
    closeTicket = 'Close',
    send_as_gift = 'Send as gift',
  } = useRecoilValue(translationDataState);
  const { rtl } = useRecoilValue(tourConfigsState);

  return (
    <TicketItemMainWrap className="bl-ticket-item" rtl={rtl}>
      <div className="bl-ticket-desc">
        <div className="bl-ticket-number-text">
          {user} {ticketNum + 1}
        </div>
        <div className="bl-ticket-number">{ticketNum + 1}</div>
        <div className="bl-ticket-triangle" />
      </div>
      <div className="bl-ticket-data">
        <div className="bl-field-1">
          <label>
            <span>*{capitalize(full_name)}</span>
            <input
              className="bl-text-input"
              onChange={(ev: any) =>
                setTicketData({
                  id: ticket.id,
                  target: 'fullName',
                  value: ev.target.value,
                })
              }
            />
          </label>
        </div>
        <div className="bl-field-2">
          <label>
            <span>*{capitalize(email)}</span>
            <input
              className="bl-text-input"
              onChange={(ev: any) =>
                setTicketData({
                  id: ticket.id,
                  target: 'email',
                  value: ev.target.value,
                })
              }
            />
          </label>
        </div>
        <div className="bl-field-3">
          {ticketNum > 0 && (
            <div className="bl-field-close" onClick={() => removeTicket(ticket.id)}>
              <div className="bl-close-circle">
                <i className="fas fa-times" />
              </div>
              {capitalize(closeTicket)}
            </div>
          )}
          <label>
            {send_as_gift}
            <Switch
              onColor="#ea475c"
              checked={ticket.isGift}
              onChange={(newIsGift: boolean) =>
                setTicketData({
                  id: ticket.id,
                  target: 'isGift',
                  value: newIsGift,
                })
              }
            />
          </label>
        </div>
        <div className="bl-ticket-ending">
          <div className="bl-ticket-end-rect bl-rect-1" />
          <div className="bl-ticket-end-rect bl-rect-2" />
          <div className="bl-ticket-end-rect bl-rect-3" />
        </div>
      </div>
    </TicketItemMainWrap>
  );
};

export default UserCard;
